import { useCallback, useEffect } from 'react';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import { useAuth } from '@hooks/useAuth';

export default function useMediaViewerReviewAudioVideoTour({
  isAssetReady,
  isAudio,
  isPreparing,
  isUnsupported
}: {
  isAssetReady: boolean;
  isAudio: boolean;
  isPreparing: boolean;
  isUnsupported: boolean;
}) {
  const user = useAuth(false);
  const { onStartTour, tourData, onCompleteStep } = useOnboardingProcess();
  const completedOnboardingSteps = user?.user?.completedOnboardingSteps || [];

  const onStartTimeRangeFeedback = useCallback(() => {
    onStartTour({
      type: 'review-audio-video',
      onClickNext: (_currentStep, isExitTour) => {
        if (isExitTour) {
          onCompleteStep({ type: 'review-audio-video', hideCongrats: true });
        }
      },
      onClickPrev: (_currentStep, isExitTour) => {
        if (isExitTour) {
          onCompleteStep({ type: 'review-audio-video', hideCongrats: true });
        }
      }
    });
  }, [onStartTour, onCompleteStep]);

  useEffect(() => {
    if (user?.user?.type !== 'internal') return;
    if (tourData?.type) return;
    if (completedOnboardingSteps.includes('review-audio-video')) return;
    if (!isAudio || isUnsupported) return;
    if (isPreparing) return;
    if (!isAssetReady) return;
    onStartTimeRangeFeedback();
  }, [
    isAssetReady,
    isAudio,
    isPreparing,
    isUnsupported,
    user?.user?.type,
    completedOnboardingSteps,
    tourData?.type,
    onStartTimeRangeFeedback
  ]);

  return null;
}
